import { LinearProgress, Typography } from "@mui/material";
import { useStudentAttemptAnswers } from "../../api/getAttemptAnswers";
import RichText from "../../../../ui/components/RichText";

export const AttemptAnswers = ({ enrollmentId, attemptId }) => {
  const { data, isLoading } = useStudentAttemptAnswers({
    enrollmentId,
    attemptId,
  });
  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <>
      {data?.map((question, index) => (
        <>
          <Typography>Pergunta - {index + 1}</Typography>
          <RichText value={question.statement} />
          <Typography>Resposta</Typography>
          {question.answer ? (
            <RichText value={question.answer} />
          ) : (
            <Typography color="error">Sem reposta</Typography>
          )}
        </>
      ))}
    </>
  );
};
